import type { SVGProps } from 'react'

const SvgStepInto = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960' {...props}>
    <path d='M395-115q-35-35-35-85t35-85q35-35 85-35t85 35q35 35 35 85t-35 85q-35 35-85 35t-85-35m45-438v-287q0-17 11.5-28.5T480-880q17 0 28.5 11.5T520-840v287l75-75q11-11 27.5-11t28.5 11q12 12 12 28.5T651-571L508-428q-12 12-28 12t-28-12L308-572q-11-11-11.5-27.5T308-628q11-11 28-11t28 11z' />
  </svg>
)

export default SvgStepInto
